import { type RequestStatus } from "@fitness-app/data-models";
import { type ExerciseAggregateStats, type ExerciseStats } from "@fitness-app/data-models/entities/ExerciseStats";

export const TRAINEE_WORKOUTS_STATS_REDUCER_NAME = "traineeWorkoutsStats";

export interface TraineeWorkoutsStatsReducer {
  exercisesRecordsList: ExerciseAggregateStats[];
  exercisesRecordsListStatus: null | RequestStatus;
  /**
   * Whose records `exercisesRecordsList` holds. The admin switches between clients within one
   * store, so a consumer must be able to tell "not loaded yet" from "loaded, but for someone else".
   */
  exercisesRecordsTraineeId: null | string;

  exerciseStatsList: ExerciseStats[];
  exerciseStatsListStatus: null | RequestStatus;
}
